import { AttributesMixin, define, Model, type } from "@type-r/models";

export interface StaticField extends AttributesMixin<typeof StaticField> { }

@define
export class StaticField extends Model {
  static attributes = {
    assetTypeId: Number,
    staticFieldItems: [type({
      fieldId: Number,
      fieldName: String,
      value: String  
    })]
  };
}
